// @ts-ignore
import Webpush from 'webpush-client'

export async function initWebPush(serverKey: string, subscribeUrl: string, jwtToken: string) {
    const WebPushClient = await Webpush.create({
        serviceWorkerPath: '/js/webpush-sw.js',
        serverKey,
        subscribeUrl,
        headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
        }
    })
    return WebPushClient
}
